import * as Actions from 'actions/base-station';
import { GetStationLocationParams, StationLocation } from 'models/base-station';
import { Repository } from 'utils/repository';

export type State = Repository<StationLocation, GetStationLocationParams, 'id'>;
const initState: State = Repository.create('id');

export const reducer = (state: State = initState, action: Actions.Action): State => {
  switch (action.type) {
    case Actions.BASE_STATION_LOCATION_DATA_LOAD_START:
      return state.setFetched(action.params, false);
    case Actions.BASE_STATION_LOCATION_DATA_LOAD_FAILURE:
      return state.setFetched(action.params, true);
    case Actions.BASE_STATION_LOCATION_DATA_LOAD_SUCCESS:
      return state
        .setFetched(action.params, true)
        .setData(action.params, action.data);
    case Actions.BASE_STATION_LOCATION_LOCK:
      return state.setLocked(action.locationId, true);
    case Actions.BASE_STATION_LOCATION_UNLOCK:
      return state.setLocked(action.locationId, false);
    case Actions.BASE_STATION_LOCATION_CHANGE:
      return state.changeModel(
        action.location.id,
        action.options.delete ? undefined : action.location
      );

    default:
      return state;
  }
};
